package com.nonopn.skydome.common.app.pages.estimate

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.rounded.Settings
import androidx.compose.material3.DrawerState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nonopn.skydome.common.app.pages.main.view.map.IconButton
import com.nonopn.skydome.common.app.pages.main.view.map.MapButtons
import com.nonopn.skywatcher.design.theme.AppSizes
import korlibs.io.async.launch

@Composable
fun EstimateMapOverlay(
    modifier: Modifier,
    model: EstimateScreenModel,
    drawerState: DrawerState
) {
    val scope = rememberCoroutineScope()

    Box(modifier.padding(AppSizes.map.cardVerticalPadding)) {
        MapButtons(
            Modifier.align(Alignment.TopStart),
            model
        )

        if (EstimateValidationMode.AdminCanValidate == model.validationMode) {
            IconButton(
                modifier = Modifier.align(Alignment.TopEnd),
                imageVector = Icons.Rounded.Settings,
                contentDescription = "Settings",
                onClick = {
                    scope.launch {
                        drawerState.open()
                    }
                }
            )
        }

        Column(
            modifier = Modifier.align(Alignment.BottomEnd).padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp, Alignment.Bottom),
            horizontalAlignment = Alignment.End
        ) {
            when (model.validationMode) {
                EstimateValidationMode.UserCanpay -> {
                    EstimateViewPayButton(
                        modifier = Modifier,
                        model = model,
                    )
                }

                EstimateValidationMode.AdminCanValidate -> {
                    EstimateViewAdminValidationButton(
                        modifier = Modifier,
                        model = model,
                    )
                }

                EstimateValidationMode.ReadOnly -> {
                    // nothing
                }
            }
        }
    }
}
